function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../saito-overlay/saito-overlay');
var SaitoImageOverlayTemplate = require('./saito-image-overlay.template');
var SaitoImageOverlay = /*#__PURE__*/function () {
  function SaitoImageOverlay(app, mod, image_array) {
    _classCallCheck(this, SaitoImageOverlay);
    this.app = app;
    this.mod = mod;
    this.image_array = image_array;
    this.image_idx = 0;
    this.overlay = new SaitoOverlay(app, mod);
    this.keydown_handler = null;
  }
  return _createClass(SaitoImageOverlay, [{
    key: "render",
    value: function render() {
      var _this = this;
      var image_idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var io_self = this;

      //
      // allow rendering from arbitrary points
      //
      if (image_idx > -1) {
        this.image_idx = image_idx;
      }
      this.detachEvents();
      this.overlay.show(SaitoImageOverlayTemplate(this.app, this.mod), function () {
        return _this.detachEvents();
      });
      if (this.image_array.length == 1) {
        this.hideArrowLeft();
        this.hideArrowRight();
      }
      this.image_array.forEach(function (img, idx) {
        var oImg = document.createElement('img');
        oImg.setAttribute('src', img);
        oImg.setAttribute('data-index', idx);
        oImg.setAttribute('class', 'saito-overlay-img');
        oImg.setAttribute('id', 'saito-overlay-img-' + idx);
        document.querySelector('#saito-overlay-img-cont').appendChild(oImg);

        //
        // and show selected
        //
        if (io_self.image_idx == idx) {
          _this.showImage(idx);
        }
      });
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.getElementById('saito-img-arrow-box-left').addEventListener('click', function (e) {
        _this2.image_idx--;
        if (_this2.image_idx <= 0) {
          _this2.image_idx = 0;
        }
        _this2.hideAllImgs();
        _this2.showImage(_this2.image_idx);
      });
      document.getElementById('saito-img-arrow-box-right').addEventListener('click', function (e) {
        _this2.image_idx++;
        if (_this2.image_idx >= _this2.image_array.length) {
          _this2.image_idx = _this2.image_array.length - 1;
        }
        _this2.hideAllImgs();
        _this2.showImage(_this2.image_idx);
      });

      //
      // keypress events
      //
      this.keydown_handler = function (event) {
        // left
        if (event.keyCode === 37) {
          var obj = document.getElementById('saito-img-arrow-box-left');
          if (obj) {
            if (obj.style.display != 'none') {
              document.getElementById('saito-img-arrow-box-left').click();
            }
          }
        }

        // right
        if (event.keyCode === 39) {
          var _obj = document.getElementById('saito-img-arrow-box-right');
          if (_obj) {
            if (_obj.style.display != 'none') {
              document.getElementById('saito-img-arrow-box-right').click();
            }
          }
        }

        // right
        if (event.keyCode === 27) {
          _this2.overlay.close();
        }
      };
      document.addEventListener('keydown', this.keydown_handler);
    }
  }, {
    key: "detachEvents",
    value: function detachEvents() {
      if (!this.keydown_handler) {
        return;
      }
      document.removeEventListener('keydown', this.keydown_handler);
      this.keydown_handler = null;
    }
  }, {
    key: "showImage",
    value: function showImage(idx) {
      var _this3 = this;
      var img_showing = document.querySelector('#saito-overlay-img-' + idx);
      if (img_showing) {
        img_showing.style.display = 'block';
        setTimeout(function () {
          _this3.checkArrows(img_showing);
        }, 100);
      }
    }
  }, {
    key: "checkArrows",
    value: function checkArrows(img) {
      this.showArrows();
      if (this.image_idx <= 0) {
        this.hideArrowLeft();
      }
      if (this.image_idx >= this.image_array.length - 1) {
        this.hideArrowRight();
      }
      var buffer = window.innerWidth > 535 ? 30 : 0;
      var img_pos = img.getBoundingClientRect();
      var left_arrow_pos = img_pos.x - buffer;
      var right_arrow_pos = window.innerWidth - img_pos.x - img_pos.width - buffer;
      if (document.querySelector('#saito-img-arrow-box-left')) {
        document.querySelector('#saito-img-arrow-box-left').style.left = '-' + left_arrow_pos + 'px';
      }
      if (document.querySelector('#saito-img-arrow-box-right')) {
        document.querySelector('#saito-img-arrow-box-right').style.right = '-' + right_arrow_pos + 'px';
      }
    }
  }, {
    key: "hideAllImgs",
    value: function hideAllImgs() {
      document.querySelectorAll('.saito-overlay-img').forEach(function (img) {
        img.style.display = 'none';
      });
      this.hideArrowLeft();
      this.hideArrowRight();
    }
  }, {
    key: "showArrows",
    value: function showArrows() {
      if (document.querySelector('#saito-img-arrow-box-left')) {
        document.querySelector('#saito-img-arrow-box-left').style.display = 'block';
      }
      if (document.querySelector('#saito-img-arrow-box-right')) {
        document.querySelector('#saito-img-arrow-box-right').style.display = 'block';
      }
    }
  }, {
    key: "hideArrowLeft",
    value: function hideArrowLeft() {
      if (document.querySelector('#saito-img-arrow-box-left')) {
        document.querySelector('#saito-img-arrow-box-left').style.display = 'none';
      }
    }
  }, {
    key: "hideArrowRight",
    value: function hideArrowRight() {
      if (document.querySelector('#saito-img-arrow-box-right')) {
        document.querySelector('#saito-img-arrow-box-right').style.display = 'none';
      }
    }
  }]);
}();
module.exports = SaitoImageOverlay;